<template>
<div>
  <UFormGroup label="Search Name" name="name" class="mb-5">
      <UInput v-model="search.name" />
    </UFormGroup>    

    <UFormGroup label="Threshold" name="threshold" class="mb-5">
      <UInput v-model="search.threshold" />
    </UFormGroup>    

    <UFormGroup label="Description" name="description" class="mb-5">
      <UTextarea v-model="search.description" />
    </UFormGroup>    
</div>
</template>

<script setup lang="ts">
import type { Search } from '~/common/types/types';

const search = defineModel({
  required: true,
  type: Object as PropType<Search>   
})
</script>